import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logoutImg from 'assets/img/icons/spot-illustrations/45.png';
import paths from 'routes/paths';
import { BRAND_NAME } from 'helpers/brand';

const loginPaths = {
  simple: paths.simpleLogin,
  split: paths.splitLogin,
  card: paths.cardLogin
};

const LogoutContent = ({ layout, titleTag: TitleTag }) => {
  // На любом заходе на logout-страницу — чистим session-данные. Раньше
  // только ProfileDropdown logout-click это делал, прямой переход на
  // /auth/.../logout оставлял token + currentProjectId → следующий
  // login авто-логинил и сразу подтягивал последний проект (виделось
  // как «помнит teslapay»). currentProjectId — основной симптом, но
  // чистим всё session-state'ом ради consistency.
  useEffect(() => {
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('currentProjectId');
    } catch {
      /* ignore — quota, private mode и т.п. */
    }
  }, []);

  return (
    <>
      <img
        className="d-block mx-auto mb-4"
        src={logoutImg}
        alt="shield"
        width={100}
      />
      <TitleTag>До скорых встреч!</TitleTag>
      <p>
        Спасибо за работу с {BRAND_NAME}.{' '}
        <br className="d-none d-sm-block" />
        Вы успешно вышли из системы.
      </p>
      <Button
        as={Link}
        color="primary"
        size="sm"
        className="mt-3"
        to={loginPaths['simple']}
      >
        <FontAwesomeIcon
          icon="chevron-left"
          transform="shrink-4 down-1"
          className="me-1"
        />
        Вернуться на сайт
      </Button>
    </>
  );
};

LogoutContent.propTypes = {
  layout: PropTypes.string,
  titleTag: PropTypes.string
};

LogoutContent.defaultProps = {
  layout: 'simple',
  titleTag: 'h4'
};

export default LogoutContent;
